import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./HelpSupportStyle.scss";
import { Header } from "./components/header/Header";
import { Footer } from "./components/footer/Footer";
import { Search } from "./components/search/Search";
import { ChatBot } from "./components/chatBot/ChatBot";

export const VzyHelpSupportLayOut = (props) => {
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const isHelpSupportPage = location.pathname === "/VZYSupport/helpSupport";

  return (
    <div className="vzy-help-support-wrapper">
      <Header />
      {isHelpSupportPage && <Search isScrolled={isScrolled} />}
      {props.children}
      <Footer />
      <ChatBot />
    </div>
  );
};
